const PetExercise = () => import(/* webpackPrefetch: true, webpackChunkName: "pet-exercise-component" */ '@/app/views/main-view/_shared/_components/pet-exercise-component/pet-exercise-component.vue');

export default {
    name: 'PetExerciseContainer',
    components: { PetExercise },
}